import * as React from 'react';

function SvgOpenCircuit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 109.09"
      {...props}
    >
      <path d="M50 25.03a25 25 0 00-25-25 25 25 0 00-25 25v30.52h50zM11.83 87.5a5.19 5.19 0 01-2-.4v19.68a2.28 2.28 0 002.08 2.3 2.22 2.22 0 002.36-2.22V86.92a5 5 0 01-2.44.58z" />
      <path d="M15.14 64.25l8.2-8.8h-6.12l-5.34 5.74a7.88 7.88 0 00-2.1 5.37v9.69c1.41-.5 3.08.88 4.44.39v-10a3.39 3.39 0 01.92-2.39zM40.85 78.25v-.12a9.21 9.21 0 00-4.27-1.16 9.21 9.21 0 014.3 1.15V66.56a7.84 7.84 0 00-2.11-5.37l-5.37-5.74h-6.11l8.21 8.8a3.38 3.38 0 01.9 2.33v11.54c1.48.13 3.07-.46 4.45.13zM38.83 88.75a5 5 0 01-2.43-.59v18.7a2.22 2.22 0 002.36 2.22 2.28 2.28 0 002.09-2.3V88.36a5.12 5.12 0 01-2.02.39z" />
    </svg>
  );
}

export default SvgOpenCircuit;
